import { createSlice } from 'utils/@reduxjs/toolkit';
import { PayloadAction } from '@reduxjs/toolkit';
import {
  ISeatingChartReportsByAvailability,
  ISeatingChartState,
} from './types';

const sliceName = 'seatingChart';

export const initialState: ISeatingChartState = {
  reportsByAvailability: null,
};

export const seatingChartSlice = createSlice({
  name: sliceName,
  initialState,
  reducers: {
    setReportsByAvailability: (
      state,
      action: PayloadAction<ISeatingChartReportsByAvailability>,
    ) => {
      state.reportsByAvailability = action.payload;
    },
  },
});

export const {
  actions: { setReportsByAvailability },
} = seatingChartSlice;

export default seatingChartSlice.reducer;
